module.exports = "<div class=\"m-slick\">\r\n    <div class=\"item g-ratio-box\" v-for=\"image in images\">\r\n        <img :data-lazy=\"image | fnjiImage\" style=\"display: none;\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./common/component/image-slick.html
// module id = 266
// module chunks = 0